import { render, staticRenderFns } from "./AddTemplateMessage.vue?vue&type=template&id=6e572f2b&scoped=true"
import script from "./AddTemplateMessage.vue?vue&type=script&lang=js"
export * from "./AddTemplateMessage.vue?vue&type=script&lang=js"
import style0 from "./AddTemplateMessage.vue?vue&type=style&index=0&id=6e572f2b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e572f2b",
  null
  
)

export default component.exports